import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [구성정보/E2E] 장비목록 테이블 조회
   * @author kimjy
   * @param  {Object} params managegroupId
   * @return {Object}        선택된 그룹에 따른 장비목록
   */
  getE2eConfigInfoDeviceList(params) {
    return axios.post(`${baseUrl}/config/get-e2e-config-info-device-list.do`, params);
  },
  /**
   * [구성정보/E2E] 장비목록 테이블 엑셀 출력 - 필터링된 데이터만 엑셀출력 가능하도록 수정
   * @author kimjy -> NaJY
   * @param  {Object} params managegroupId
   */
  excelExportE2eConfigInfoDeviceList(params) {
    return axios.post(`${baseUrl}/config/export-e2e-config-info-device-list.do`, params);
  },

  /**
   * 노드>구성현황 기본정보
   * @author hyo
   * @param
   * @return
   */
  getE2eConfigInfoBasic(params) {
    return axios.post(`${baseUrl}/config/get-e2e-config-info-basicstatus.do`, params);
  },

  /**
     * 노드>구성현황 DB 리스트
     * @author hyo
     * @param
     * @return
   */
  getDbList(params) {
    return axios.post(`${baseUrl}/config/get-e2e-db-list.do`, params);
  },
  /**
     * 노드>구성현황 수정
     * @author hyo
     * @param
     * @return
     */
  updateE2eObjConfig(params) {
    return axios.post(`${baseUrl}/config/update-e2e-obj-config.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/config/e2e/e2e-info.js